import * as React from "react";
import "./index.css";

const CheckBox = ({ checked, onChange, label, disabled = false, className = "", name, id, ...rest }) => {
  const containerClassName = ["checkbox-container", className].filter(Boolean).join(" " );
  const inputId = id || name || undefined;
  return (
    <div className={containerClassName}>
      <input
        name={name}
        id={inputId}
        type="checkbox"
        disabled={disabled}
        checked={checked}
        onChange={onChange}
        {...rest}
      />
      {label && <label htmlFor={inputId}>{label}</label>}
    </div>
  );
};

export default CheckBox;
